import { useMemo } from "react";
import DownloadNH from "../../Common/DownloadNH";
import TravelInsights from "../../Common/TravelInsights/TravelInsights";
import MainLayout from "../../MainLayout";
import BlogSecTravelUpdate from "../BlogSecTravelUpdate/BlogSecTravelUpdate";
import CommonHeader from "@/Common/CommonHeader/CommonHeader";

export default function BlogMonth({
  monthSlug = "",
  monthTitle = "",
  initialBlogList = [],
  initialBlogMeta = null,
  country = "UAE",
}) {
  const regionTagSlug = useMemo(
    () => (monthSlug ? [monthSlug] : undefined),
    [monthSlug]
  );

  return (
    <div>
      <MainLayout hideHeader>
        <CommonHeader
          buttonText=""
          buttonLink="#blog-section"
          bgImage={`/images/blog/${monthSlug}.webp`}
        />
        <TravelInsights
          isBlogPage={true}
          regionTagSlug={regionTagSlug}
          initialBlogList={initialBlogList}
          initialBlogMeta={initialBlogMeta}
          country={country}
        />
        <BlogSecTravelUpdate />
        <DownloadNH />
      </MainLayout>
    </div>
  );
}
